import React from 'react';
import { Link } from 'react-router-dom';
import { SERVICE_ANCHORS, SITE } from '../siteInfo';
import { UI, localizePath, useLang } from '../i18n';

const linkClass = 'text-gray-300 hover:text-white transition-colors';

const Footer = () => {
    const lang = useLang();
    const t = UI[lang].footer;
    const lp = (path) => localizePath(path, lang);

    return (
        <footer className="bg-[#0A1F30] text-gray-300">
            <div className="container mx-auto px-4 py-12 grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
                <div>
                    <h2 className="text-white text-lg font-bold mb-3">{SITE.name}</h2>
                    <p className="text-sm leading-relaxed">{t.tagline}</p>
                </div>

                <div>
                    <h2 className="text-white text-base font-semibold mb-3">{t.corporate}</h2>
                    <ul className="space-y-2 text-sm">
                        <li><Link to={lp('/company')} className={linkClass}>{t.about}</Link></li>
                        <li><Link to={lp('/research')} className={linkClass}>{t.research}</Link></li>
                        <li><Link to={lp('/research/videos')} className={linkClass}>{t.videos}</Link></li>
                        <li><Link to={lp('/research/design-guide')} className={linkClass}>{t.guide}</Link></li>
                        <li><Link to={lp('/research/calculators')} className={linkClass}>{t.calculators}</Link></li>
                        <li><Link to={lp('/contact')} className={linkClass}>{t.contact}</Link></li>
                    </ul>
                </div>

                <div>
                    <h2 className="text-white text-base font-semibold mb-3">{t.services}</h2>
                    <ul className="space-y-2 text-sm">
                        {t.serviceLinks.map((label, i) => (
                            <li key={label}>
                                <Link to={lp(`/services#${SERVICE_ANCHORS[i]}`)} className={linkClass}>{label}</Link>
                            </li>
                        ))}
                        {t.otherServices.map((label) => <li key={label}>{label}</li>)}
                    </ul>
                </div>

                <div>
                    <h2 className="text-white text-base font-semibold mb-3">{t.contact}</h2>
                    <address className="not-italic space-y-2 text-sm">
                        <p className="m-0">{SITE.street}<br />{SITE.city}{t.country}</p>
                        <p className="m-0"><a href={SITE.phoneHref} className={linkClass}>{SITE.phone}</a></p>
                        <p className="m-0"><a href={`mailto:${SITE.email}`} className={linkClass}>{SITE.email}</a></p>
                    </address>
                </div>
            </div>

            <div className="border-t border-white/10">
                <div className="container mx-auto px-4 py-4 flex flex-col sm:flex-row justify-between gap-2 text-xs text-gray-400">
                    <span>© {new Date().getFullYear()} {SITE.legalName}</span>
                    <Link to="/admin/login" className="text-gray-400 hover:text-gray-200">{t.admin}</Link>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
